module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-average/events-average.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-average/events-average.component.css
// module chunks = main